import { useEffect, useState } from "react";
import { ceil } from "lodash";
import { getDataFromLocalStorage } from "utils/helpers";
import { useSelector } from "react-redux";
import "./DashboardQuery.scss";

const DashboardQuery = ({ queryData }) => {
  const reduxData = useSelector((state) => state.global);
  const { isDarkMode } = reduxData || {};
  const [SubscriptionData, setSubscriptionData] = useState(null);
  const { used, available, to_vest } = queryData;
  const total = used + available + to_vest;
  const perUsed = ceil((used / total) * 100);
  // let perPendigtill = 100 - perUsed;
  let perPendigtill = Math.ceil((available / total) * 100);

  if (SubscriptionData && SubscriptionData?.type === "nowpayments") {
    perPendigtill = Math.floor((available / total) * 100);
  }
  const perPending = Math.max(0, 100 - (perUsed + perPendigtill));

  const fetchSubscriptiondata = () => {
    const { sub_type } = getDataFromLocalStorage()?.subscription || {};
    setSubscriptionData({
      type: sub_type || "",
    });
  };

  useEffect(() => {
    fetchSubscriptiondata();
  }, []);
  return (
    <div id="dashboardquery-container">
      <div
        className={`${
          isDarkMode
            ? "dashBoardBorder-dark cmb-26 un"
            : "b-dee3 br-16 cp-20 cmb-26 un"
        } `}
      >
        <div className={`${isDarkMode ? "dashboardQuery-dark" : ""}`}>
          <div className="fb-center">
            <div
              className={`text-17-500 ${
                isDarkMode ? "color-ffff" : "color-2749"
              }`}
            >
              Your plan query
            </div>
            <div className="fa-center gap-3">
              <div className="fa-center gap-2 mb-2">
                <span className="bg-56ff h-15 br-8 w-26 d-flex" />
                <span
                  className={`text-16-600 ${
                    isDarkMode ? "color-ffff" : "color-7e91"
                  }`}
                >
                  {perUsed}%
                </span>
                <span
                  className={`text-14-500 ${
                    isDarkMode ? "color-c9c9" : "color-b5c0"
                  }`}
                >
                  Used
                </span>
              </div>
              <div className="fa-center gap-2 mb-2">
                <span className="bg-bbff h-15 br-8 w-26 d-flex" />
                <span
                  className={`text-16-600 ${
                    isDarkMode ? "color-ffff" : "color-7e91"
                  }`}
                >
                  {perPendigtill}%
                </span>
                <span
                  className={`text-14-500 ${
                    isDarkMode ? "color-c9c9" : "color-b5c0"
                  }`}
                >
                  Available
                </span>
              </div>
              <div className="fa-center gap-2 mb-2">
                <span className="bg-edf0 h-15 br-8 w-26 d-flex" />
                <span
                  className={`text-16-600 ${
                    isDarkMode ? "color-ffff" : "color-7e91"
                  } `}
                >
                  {perPending}%
                </span>
                <span
                  className={`text-14-500 ${
                    isDarkMode ? "color-c9c9" : "color-b5c0"
                  }`}
                >
                  Remaining
                </span>
              </div>
            </div>
          </div>
          <div className="mt-3 d-flex align-items-center gap-1 cpb-36 cpt-20">
            <div className="d-flex flex-grow-1">
              {perUsed > 0 && (
                <div
                  className="position-relative user-rel"
                  style={{ width: `${perUsed}%` }}
                >
                  <div className="progress br-22 h-26 use-bar">
                    <div
                      className="progress-bar h-100 bg-56ff"
                      role="progressbar"
                      style={{ width: "100%" }}
                      aria-valuenow="100"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    />
                  </div>
                  <div className="use-used">
                    <div
                      className={`b-edf0 counter-indi ${
                        isDarkMode ? "bg-4d6c" : ""
                      }`}
                    >
                      <div
                        className={`text-12-400 ${
                          isDarkMode ? "color-ffff" : "color-2749"
                        } position-relative`}
                      >
                        <div className="tri" />
                        {`${used?.toLocaleString()} Used`}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div
                className="position-relative user-available-bar"
                style={{ width: `${perPendigtill}%` }}
              >
                <div
                  className={`progress br-22 h-26 ${
                    !perPending ? "remain-bar" : "remain-bar-super"
                  }`}
                >
                  <div
                    className="progress-bar h-100 bg-bbff"
                    role="progressbar"
                    style={{ width: "100%" }}
                    aria-valuenow="100"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  />
                </div>
                <div className="user-available">
                  <div
                    className={`b-edf0 middle-counter-indi ${
                      isDarkMode ? "bg-4d6c" : ""
                    }`}
                  >
                    <div
                      className={`text-12-400 ${
                        isDarkMode ? "color-ffff" : "color-2749"
                      } position-relative`}
                    >
                      <div className="tri" />
                      {`${available?.toLocaleString()} Available`}
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="position-relative user-remaining-bar"
                style={{ width: `${perPending}%` }}
              >
                <div className="progress br-22 h-26">
                  <div
                    className="progress-bar h-100 bg-edf0"
                    role="progressbar"
                    style={{ width: "100%" }}
                    aria-valuenow="100"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  />
                </div>
                <div className="user-remaining">
                  <div
                    className={`b-edf0 counter-indi-remain ${
                      isDarkMode ? "bg-4d6c" : ""
                    }`}
                  >
                    <div
                      className={`text-12-400 ${
                        isDarkMode ? "color-ffff" : "color-2749"
                      } position-relative`}
                    >
                      <div className="tri" />
                      {`${to_vest?.toLocaleString()} Remaining`}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardQuery;
